import type { LoaderFunctionArgs } from 'react-router-dom'
import { getPreparationContainers } from 'client/stock-transfers/stock-transfers.client'

export const preparationLoader = async ({ params }: LoaderFunctionArgs) => {
  const orderData = await getPreparationContainers(params.transferId!)

  orderData.containers = orderData.containers.map((container) => ({
    ...container,
    id: container.id.replace(/-shipped$/, '-embarcado')
  }))
  return orderData
}
